import { AxiosError } from 'axios';
import { POST_JOB_STATUS_REPORT_EMAIL_URL } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// ============================================================================

export interface JobStatusReportEmailPayload {
  uuid: string;
  emails: String[];
  password: string;
}
// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: () => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const usePostAdminJobStatusReportEmail = ({ onSuccess, onError }: Input = {}) => {
  const postAdminJobStatusReportEmail = async (payload: JobStatusReportEmailPayload) => {
    const res = await axiosClient.post<void>(POST_JOB_STATUS_REPORT_EMAIL_URL, payload);
    return res.data;
  };

  return useCustomMutation(postAdminJobStatusReportEmail, {
    onSuccess,
    onError,
  });
};

